<template>
  <div class="act">
    <!-- <img
      v-if="zpActivety"
      src="@/assets/GuangzhouUnicomImg/new/bgCFY.png"
      class="act-bg"
      alt=""
    /> -->
    <!-- <img src="@/assets/GuangzhouUnicomImg/new/bg.png" class="act-bg" alt="" /> -->
    <LogoHeader 
        :logoPath="require('@/assets/logo/elm/elm-unicom.png')"
        altText="中国联通"
        />
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/new/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/new/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn && isShow">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/new/lqBtn2.png"
        alt=""
      />
    </div>
    <div class="content">
      <img
        src="@/assets/GuangzhouUnicomImg/new2/top.png"
        class="topImg"
        alt=""
      />
      <div class="contentBox1">
        <div class="tcInfo">
          <img
            class="tcInfoImg"
            src="@/assets/GuangzhouUnicomImg/new/tcInfo.png"
            alt=""
          />
        </div>
        <!-- <div class="xssInfo" v-if="zpActivety">
          <img
            class="xssInfoImg"
            src="@/assets/GuangzhouUnicomImg/new/xss.png"
            alt=""
          />
          <div class="xssConent">
            <div v-if="!isEnded" class="name">距离活动结束还剩：</div>
            <Countdown :endTime="endTime" @ended="ended"></Countdown>
          </div>
        </div> -->
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
              />
            </div>
            <!-- <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
                @click="showPicker = true"
              />
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList2"
                  @confirm="selectCity"
                />
              </van-popup>
            </div> -->
            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货区省市"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>

            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit" v-if="isShow">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/new/lqBtn2.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new/tcys.png"
            alt=""
          />
        </div>
        <div class="zfxqInfo">
          <img
            class="boxImg"
            src="@/assets/GuangzhouUnicomImg/new/zfxq.png"
            alt=""
          />
        </div>
        <div class="zfxqInfo">
          <img
            class="boxImg"
            src="@/assets/GuangzhouUnicomImg/new/yhhd.png"
            alt=""
          />
        </div>
        <!-- <div class="zfxqInfo" v-if="zpActivety">
          <img
            class="boxImg"
            src="@/assets/GuangzhouUnicomImg/new/fyhlj.png"
            alt=""
          />
        </div> -->
        <div class="zfxqInfo">
          <img
            class="boxImg"
            src="@/assets/GuangzhouUnicomImg/new/cjwt.png"
            alt=""
          />
        </div>
      </div>
      <div class="contentBox1">
        <div class="fzBox">
          <img class="fzImg" src="@/assets/fzImg.png" alt="" />
        </div>
      </div>
      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/new/bottomImg.png"
        alt=""
      />
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <!-- <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog> -->

    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>

    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData.json";
import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
// import { deepClone } from "@/utils/utils";
import moment from "moment";
// import Countdown from "./components/Countdown.vue";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
export default {
  name: "GuangzhouUnicom1",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    // Countdown,
    dialogTips,
    LogoHeader,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [
        {
          name: "S",
          value: "S",
        },
      ],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      isShow: false, //下架
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.columns = [];
    this.columns = operatorData[this.spiId].cardAttribution;
    this.cardAttribution = this.columns[this.oIndex].text;
    this.cardAttributionProvince = this.columns[this.oIndex].value;
    this.cardAttributionCode = this.columns[this.oIndex].value;
    this.areaList = [];
    this.areaList.push(areaData["440000"]);
    // this.areaList2 = deepClone(this.areaList)
    // this.initAreaList2();
    this.comboData = operatorData[this.spiId].comboList[this.oIndex];
    this.comboName = this.comboData.comboName;

    if (this.spiId == "gzuni0000000001") {
      this.cardAttributionProvince = "440000";
    }

    this.dealTextList = [
      {
        name: "入网协议",
        components: "unicomDeal9",
      },
      {
        name: "用户隐私协议",
        components: "ysxy",
      },
    ];
    this.simViewLogAdd();
    this.getActivityBySpi();
  },
  watch: {
    cardAttribution(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: "GZUnicom38",
        spiId: this.spiId,
        clickName: "GZUnicom38",
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      this.areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      // console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      window.location.href =
        "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      } else if (!this.comboMobile && this.showMobile == "true") {
        this.$toast("请选择号码");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }
      let params = {
        comboLevel: this.comboData.comboLevel,
        comboName: this.comboData.comboName,
        // cardAttribution: this.areaData2.cCode,
        cardAttribution: this.cardAttributionCode,
        goodsName: operatorData[this.spiId].goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince: this.cardAttributionProvince,
        // cardAttributionProvince: this.areaData2.pCode,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.comboData.comboCode,
        goodsCode: this.comboData.goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        // this.$dialog
        //   .alert({
        //     message:
        //       "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
        //     confirmButtonColor: "#3860cf",
        //   })
        //   .then(() => {
        //     window.location.reload();
        //   });
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }
      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        // cityCode: this.areaData2.cCode,
        goodsId: this.comboData.comboCode,
        provinceCode: this.cardAttributionProvince,
        // provinceCode: this.areaData2.pCode,
      };
      const { code, result, message } = await http(
        "ltZOPnumGuessSelect2",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.act {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-image: linear-gradient(135deg, #82c9ff, #fea6ff, #91c4ff, #ebacff);
  .queryBtn {
    position: fixed;
    top: 60vh;
    right: 20px;
    width: 30px;
    z-index: 2;
  }
  .kefuBtn {
    position: fixed;
    top: 50vh;
    right: 5px;
    width: 60px;
    z-index: 2;
    color: #7a8ebb;
  }
  .act-bg {
    width: 100%;
    display: block;
  }
  .topImg {
    width: 100%;
    display: block;
  }
  .bottomImg {
    width: 100%;
    padding-top: 50px;
    display: block;
  }
  .bottomBtn {
    width: 100%;
    position: fixed;
    bottom: 43vw;
    left: 0;
    padding: 40px 40px;
    box-sizing: border-box;
    z-index: 2;
    .bottomBtnImg {
      width: 100%;
    }
  }
  .content {
    width: 100%;
    // position: absolute;
    // top: 100vw;
    // z-index: 1;
    .contentBox1 {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      .tcInfo {
        width: 100%;
        position: relative;
        .tcInfoImg {
          width: 100%;
        }
      }
      .xssInfo {
        width: 100%;
        position: relative;
        padding-top: 20px;
        .xssInfoImg {
          width: 100%;
        }
        .xssConent {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #fff;
          height: 13vw;
          line-height: 13vw;
        }
      }
      .bmInfo {
        background-color: #fff;
        border-radius: 15px;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        .bmTitle {
          text-align: center;
          font-weight: 600;
          color: #3860cf;
          font-size: 20px;
        }
        .bmContent {
          width: 100%;
          padding: 10px 0;
          .scroll-content {
            height: 120px;
            overflow: hidden;
          }
          .bmItem {
            width: 100%;
            display: flex;
            border-bottom: 1px solid #cdd8f3;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            box-sizing: border-box;
            .bmItemName {
              width: 30%;
            }
            .bmItemPhone {
              width: 40%;
            }
            .bmItemTime {
              width: 30%;
              text-align: right;
            }
          }
        }
      }
      .tcysInfo {
        margin-top: 20px;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        .tcysImg {
          width: 100%;
        }
      }
      .zfxqInfo {
        width: 100%;
        margin-top: 20px;
        box-sizing: border-box;
        position: relative;
        .boxImg {
          width: 100%;
        }
      }
    }
    .contentBox2 {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      .userInfo {
        width: 100%;
        background-color: #fff;
        padding: 30px 20px;
        font-size: 14px;
        box-sizing: border-box;
        border-radius: 13px;
        .form-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #eee;
          .form-label {
            width: 30vw;
          }
          /deep/.van-field__control {
            text-align: right;
          }
        }
        .dealText {
          padding: 20px 0;
          width: 100%;
          box-sizing: border-box;
          .read {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            word-wrap: break-word;
            overflow-wrap: break-word;
            white-space: normal;
            font-size: 12px;
            color: #cec9cc;
            .van-checkbox {
              margin-right: 4px;
            }
            .deal {
              word-wrap: break-word;
              overflow-wrap: break-word;
              white-space: normal;
            }
            .xy {
              color: #3860cf;
              word-wrap: break-word;
              overflow-wrap: break-word;
              white-space: normal;
            }
          }
        }
      }
      .btn {
        width: 100%;
        .lqBtn {
          width: 100%;
        }
      }
    }
  }
}
.numDialog {
  height: 20rem;
  .numClose {
    position: fixed;
    top: 0;
    left: 0;
    width: 90%;
    height: 1.5rem;
    background-color: #fff;
    padding: 0.8rem 1.5rem 0.6rem 0.8rem;
    text-align: right;
  }
  .numBox {
    margin-top: 1.8rem;
    height: 14rem;
    overflow: hidden;
    overflow-y: scroll;
    .numContent {
      display: inline-block;
      width: 50%;
      line-height: 4rem;
      span {
        display: flex;
        justify-content: space-around;
      }
    }
  }
  .numBtn {
    position: fixed;
    left: 35%;
    bottom: 0.8rem;
    text-align: center;
  }
}
.kefuBox {
  width: 100%;
  display: flex;
  padding-top: 10px;
  justify-content: center;
  align-items: center;
  .kefuQRCode {
    width: 40%;
  }
}
.sizeBox {
  padding: 20px;
  .sizeBoxList {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .sItem {
      border: 1px solid #eee;
      margin-right: 10px;
      margin-bottom: 10px;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      &.active {
        border-color: #338fcc;
        color: #338fcc;
      }
    }
  }
}
.activeInfo {
  padding-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .activeLeft {
    color: #e03737;
  }
  .activeRight {
    color: #5186db;
  }
}
.dialogTips {
  width: 100%;
  max-height: 70vh;
  overflow: scroll;
  background-color: #e03737;
  .tipsImg {
    width: 100%;
    display: block;
  }
}
select {
  font-size: 14px;
  text-align: right;
  width: 30%;
  height: 44px;
  border: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  font-family: "Arial", sans-serif;
  color: #333;

  option {
    background-color: #fff;
    border: none;
    padding: 0;
    margin: 0;
  }
}
</style>
